import { Link } from "react-router-dom";
import type { Product } from "../data/products";
import { brandConfig } from "../config/brandConfig";

type ProductCardProps = {
  productSpecific: Product;
};

export default function ProductCard({ productSpecific }: ProductCardProps) {
  const { slug, name, sku, images, short } = productSpecific;
  return (
    <div className="card">
      <Link to={`/produits/${slug}`}>
        <img
          src={images[0]}
          alt={name}
          style={{
            width: "100%",
            background: "rgba(255,255,255,0.06)",
            borderRadius: 12,
          }}
        />
      </Link>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <div>
          <h2 className="product-card__title">{name}</h2>
          <div className="small">SKU: {sku}</div>
        </div>
      </div>
      <p className="small" style={{ marginTop: 8 }}>
        {short}
      </p>
      <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
        <Link
          to={`/produits/${slug}`}
          className="btn"
          aria-label={`Voir ${name}`}
        >
          Voir le produit
        </Link>
      </div>
      {brandConfig.isResellerBrand && (
        <p className="small" style={{ marginTop: 6, opacity: 0.7 }}>
          {brandConfig.salesChannelLabel}
        </p>
      )}
    </div>
  );
}
